import styled from 'styled-components';

const Accordion = styled.ul`
  padding: 0;

  &:not(:last-child) {
    margin-bottom: 30px;
  }
`;

export default Accordion;
